var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#00A55E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7952 56.9894C45.3138 57.508 46.1548 57.508 46.6734 56.9893L65.4549 38.2058C66.3624 37.2982 67.8339 37.2979 68.7418 38.2051C69.6502 39.1129 69.6504 40.5851 68.7424 41.4932L47.6125 62.623C46.5752 63.6603 44.8934 63.6603 43.8561 62.623L32.5865 51.3535C31.679 50.446 31.679 48.9746 32.5865 48.0671C33.494 47.1596 34.9654 47.1596 35.8729 48.0671L44.7952 56.9894Z",
    fill: "white"
  })));
};
export default SvgSuccess;